import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Unauthorized() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Box sx={{ textAlign: 'center', py: 8 }}>
            <LockOutlined sx={{ fontSize: 80, color: 'text.disabled' }} />
            <Typography variant="h5" mt={2}>
                {t('unauthorized.title')}
            </Typography>
            <Typography color="text.secondary" mt={1}>
                {t('unauthorized.message')}
            </Typography>
            <Button variant="outlined" sx={{ mt: 3 }} onClick={() => navigate('/')}>
                {t('unauthorized.backToDashboard')}
            </Button>
        </Box>
    );
}
